<script>
	import { page } from '$app/stores'

	export let deviceType = null
	export let cityName = null
	export let regionName = null
	export let backgroundColor = null

	const { region, city } = $page.params
</script>

<nav class="breadcrumbs background-full gray {backgroundColor}">
	<div class="cont">
		<a class="text-primary-500" href="/{deviceType}">Celá ČR</a>
		<span class="text-gray">></span>
		{#if !city}
			<span>{regionName}</span>
		{:else}
			<a href="/{deviceType}/{region}">{regionName}</a>
			<span class="text-gray">></span>
			<span>{cityName}</span>
		{/if}
	</div>
</nav>

<style lang="scss">
	.breadcrumbs {
		position: relative;
		z-index: 1;

		.cont {
			max-width: 1360px;
			margin: 0 auto;
			padding: 30px 15px 0 15px;
		}
	}
</style>
